module.exports = __webpack_public_path__ + "img/usage_card2.66108cba.png";